<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; overflow-y: scroll;">
            <div style="position: relative; z-index: 1;">
                <img style="width: 100%; max-height: 390px; object-fit: cover;" :src="require('@/assets/img/event_sample.png')" alt="">
            </div>
            <div class="main_wrapper">
                <div style="padding-top: 31px; font-weight: 700;">
                    <div style="border-radius: 8px; background-color: #ff0000; display: inline-block; color: #fff; padding: 4px 13px;">D-{{ remainDay(eventDetail.end_date) }}</div>
                    <div style="font-size: 24px; line-height: 28px; margin-top: 10px;">{{ eventDetail.product_name }}</div>
                    <div style="margin-top: 10px; display: flex; align-items: center; gap: 10px;">
                        <div style="font-size: 24px; color: var(--color-main);">{{ eventDetail.discount_price | comma }}원</div>
                        <div style="font-size: 20px; color: #8a8a8a; font-weight: 400; text-decoration: line-through;">{{ eventDetail.original_price | comma }}원</div>
                        <div class="sale_box">{{ getDiscountRate(eventDetail.original_price, eventDetail.discount_price) }}% SALE</div>
                    </div>
                </div>
                <div style="margin-top: 23px; font-weight: 700;">
                    <div style="font-size: 12px;">남은 시간</div>
                    <div style="margin-top: 5px; display: flex; gap: 18px; font-size: 48px;">
                        <div style="white-space: nowrap;">{{ days }}<span style="font-size: 24px;">일</span></div>
                        <div style="display: flex; align-items: center; gap: 6px;">
                            <div>{{ hours }}</div>
                            <div style="transform: translateY(-3px);">:</div>
                            <div>{{ minutes }}</div>
                            <div style="transform: translateY(-3px);">:</div>
                            <div>{{ seconds }}</div>
                        </div>
                    </div>
                    <div style="margin-top: 15px;">
                        <div style="border-radius: 12px; height: 10px; background-color: #F2F0F0; position: relative;">
                            <div :style="{ width: progressPercent + '%' }" style="position: absolute; border-radius: 12px; background-color: var(--color-main); height: 100%;"></div>
                        </div>
                    </div>
                    <div style="margin-top: 20px; display: flex; align-items: center; justify-content: space-between; padding-bottom: 23px; border-bottom: 2px solid #f5f5f5;">
                        <div style="display: flex;">
                            <div :style="{ transform: i > 0 ? `translateX(-${20 * i}px)` : '' }" v-for="each, i in 4" :key="i">
                                <div v-if="i < 3">
                                    <ProfileImage style="width: 40px;" :imagePath="null"></ProfileImage>
                                </div>
                                <div class="plus_circle" v-else>
                                    +99
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style="font-weight: 500; font-size: 12px; color: #626262; line-height: 20px;">실시간 도전 인원</div>
                            <div style="display: flex; align-items: center; gap: 5px;">
                                <img style="width: 15px;" :src="require('@/assets/img/challenge.png')" alt="">
                                <div style="font-weight: 700; font-size: 20px; line-height: 24px; display: flex; align-items: center; gap: 3px;">2,193 <span style="color: #626262; font-weight: 500; font-size: 12px;">명</span></div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 23px; padding-bottom: 23px; border-bottom: 2px solid #f5f5f5;">
                        <div style="font-weight: 700;">상품 정보</div>
                        <div style="margin-top: 25px; font-weight: 700; font-size: 14px;">
                            <div style="display: flex; gap: 20px;">
                                <div style="color: #606060;">브랜드</div>
                                <div>{{ brand }}</div>
                            </div>
                            <div style="display: flex; gap: 20px; margin-top: 15px;">
                                <div style="color: #606060;">모델명</div>
                                <div>{{ model }}</div>
                            </div>
                            <div style="display: flex; gap: 20px; margin-top: 15px;">
                                <div style="color: #606060;">사이즈</div>
                                <div>{{ size }}</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top: 23px; margin-bottom: 20px;">
                        <div style="border-radius: 12px; background-color: #f8fafc; border: 1px solid #eff3f8; padding: 24px; font-weight: 700; font-size: 12px;">
                            <div style="display: flex; gap: 5px; align-items: center;">
                                <div class="circle_exclaim">!</div>
                                <div style="font-size: 14px;">도전하기 전에 꼭 확인해주세요</div>
                            </div>
                            <!-- <div v-for="each, i in caution_highlight_arr" :key="i + 'highlight'" :style="{ marginBottom: i === caution_highlight_arr.length - 1 ? '' : '10px' }" style="display: flex; gap: 5px; align-items: center;">
                                <div class="circle_exclaim">!</div>
                                <div style="font-size: 14px;">{{ each }}</div>
                            </div> -->
                            <ul style="padding-left: 22px; margin-top: 15px; margin-bottom: 0; display: flex; flex-direction: column; gap: 15px;">
                                <li v-for="each, i in caution_highlight_arr" :key="i + 'highlight'" style="line-height: 20px;">{{ each }}</li>
                                <li v-for="each, i in caution_arr" :key="i + 'caution'" style="line-height: 20px; color: #657489">{{ each }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="height: 110px; display: flex; gap: 20px; align-items: center; padding: 0 20px; font-weight: 700;">
            <div style="width: 66px; height: 66px; display: flex; align-items: center; justify-content: center; border: 1px solid #bbb; border-radius: 12px;">
                <img style="width: 18px;" :src="require('@/assets/img/gray_heart.png')" alt="">
            </div>
            <div style="border-radius: 12px; background-color: var(--color-main); height: 66px; flex: 1; text-align: center; line-height: 66px; color: #fff; font-size: 20px;">{{ eventDetail.discount_price | comma }}원에 도전하기</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'
import moment from "moment"

export default {
    name: 'EventPage',
    components: {
        MercenaryHeader, ProfileImage
    },
    props: {
        event_idx: {
            type: [String, Number],
            default: -1
        }
    },
    data() {
        return {
            timer: null,
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00',
            progressPercent: 0,
            eventDetail: {},
            brand: '',
            model: '',
            size: '',
            caution_highlight_arr: [],
            caution_arr: []
        }
    },
    created() {
        this.getEventDetail()
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        startTimer() {
            // 이벤트 시작 시간
            const start = moment(this.eventDetail.start_date).startOf('day')
            // 이벤트 종료 시간
            const target = moment(this.eventDetail.end_date).startOf('day')

            // 테스트용
            // let fakeNow = moment('2025-12-20 21:59:30')

            const update = () => {
                const now = moment()
                // 테스트용
                // const now = fakeNow
                const totalMs = target.diff(start)
                const remainMs = target.diff(now)

                if (remainMs <= 0) {
                    this.days = '00'
                    this.hours = '00'
                    this.minutes = '00'
                    this.seconds = '00'
                    this.progressPercent = 100
                    clearInterval(this.timer)
                    return
                }

                const diff = moment.duration(remainMs)
                const days = Math.floor(diff.asDays())
                const hours = diff.hours()
                const minutes = diff.minutes()
                const seconds = diff.seconds()

                const pad = (n) => String(n).padStart(2, '0')

                this.days = pad(days)
                this.hours = pad(hours)
                this.minutes = pad(minutes)
                this.seconds = pad(seconds)

                const elapsedMs = totalMs - remainMs
                let percent = (elapsedMs / totalMs) * 100

                percent = Math.max(0, Math.min(100, percent))
                this.progressPercent = percent.toFixed(2)

                // 테스트용
                // fakeNow = fakeNow.add(1, 'seconds')
            }

            update()
            this.timer = setInterval(update, 1000)
        },
        getDiscountRate(originalPrice, discountPrice) {
            if (!originalPrice || originalPrice <= 0) return 0

            return Math.floor(
                (1 - discountPrice / originalPrice) * 100
            )
        },
        remainDay(endDate) {
            const now = moment()
            const target = moment(endDate, 'YYYY-MM-DD').startOf('day')

            return Math.floor(
                moment.duration(target.diff(now)).asDays()
            )
        },
        async getEventDetail() {
            const parameters = {}
            parameters.event_idx = this.event_idx
            const res = await this.$Axios.get('/api/event/detail', { params: parameters })

            const eventDetail = res.data.event_detail
            this.eventDetail = eventDetail
            const productInfo = eventDetail.product_info.split('||')

            this.selectEndDate = eventDetail.end_date ?? ''
            this.brand = productInfo[0]
            this.model = productInfo[1]
            this.size = productInfo[2]

            this.caution_highlight_arr = eventDetail.caution_highlight ? eventDetail.caution_highlight.split('||') : [''];
            this.caution_arr = eventDetail.caution ? eventDetail.caution.split('||') : [''];
            this.startTimer()
        },
    }
}
</script>

<style scoped>
.main_wrapper {
    border-top-left-radius: 20px; 
    border-top-right-radius: 20px; 
    position: relative; 
    z-index: 2; 
    background-color: #fff; 
    margin-top: -20px;
    padding: 0 24px;
}

.plus_circle {
    width: 40px; 
    height: 40px; 
    border: 1px solid #fff; 
    border-radius: 50%; 
    background-color: #210f03; 
    color: #fff; 
    font-size: 14px; 
    font-weight: 500; 
    display: flex; 
    align-items: center; 
    justify-content: center;
}

.sale_box {
    font-size: 12px; 
    line-height: 20px; 
    color: var(--color-main); 
    padding: 0 3px; 
    background-color: #FFF6EA; 
    border-radius: 4px; 
    margin-left: 5px
}

.circle_exclaim {
    width: 16px; 
    height: 16px; 
    display: flex; 
    justify-content: center; 
    align-items: center; 
    border-radius: 50%;
    border: 1px solid #210f03;
    font-size: 12px;
}
</style>